import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import Main from './audience-components/main';
import { recordStatisticsEvent } from '../../services/statistics-service';

export default function Audience(props) {
  const common = commonProps();

  React.useEffect(() => {
    recordStatisticsEvent({
      event: 'audience_report_page_view',
      statisticable: 'profile',
      id: _.get(window, 'Livewire.currentUser.profile.id'),
    });
  }, []);

  if (!props.partnership) {
    return null;
  }

  return (
    <ThemeProvider theme={common}>
      <Main {...props} />
    </ThemeProvider>
  );
}

Audience.propTypes = {
  partnership: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    cachedAnalyticsDataUrls: PropTypes.shape({
      followersDataUrl: PropTypes.string,
      contributorRankingDataUrl: PropTypes.string,
      investorTypesDataUrl: PropTypes.string,
    }),
    contributors: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      profilePictureUrl: PropTypes.string,
      createdAt: PropTypes.string,
    })).isRequired,
  }),
  investorTypes: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  contributorCount: PropTypes.number.isRequired,
};

Audience.defaultProps = {
  partnership: null,
};
